<template>
  <sidebar-item-header class="pc-note__catalog-header" :name="name" :canFold="canFold">
    笔记本目录
  </sidebar-item-header>
</template>

<script>
import SidebarItemHeader from '@/components/note/sidebar/SidebarItemHeader.vue'

export default {
  components: {
    SidebarItemHeader
  },
  props: {
    canFold: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      name: 'catalog',
      moreActions: {
        contextmenu: {
          type: 'WORKBENCH_SIDEBAR_CATALOG_MORE',
          data: {}
        }
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/variables.scss';

.pc-note__catalog-header {
  top: 0;
}
</style>
